import { useFragment } from '@apollo/client';
import { gql } from '@/__generated__';
import { MedalAvatar } from '../medal-avatar/medal-avatar';

const AwardFragment = gql(`
  fragment AwardFragment on Medal {
    id
    name
    image {
      key
    }
  }
  `);

export const Award = ({ medalId }: { medalId: string }) => {
  const { data } = useFragment({
    fragment: AwardFragment,
    fragmentName: 'AwardFragment',
    from: {
      __typename: 'Medal',
      id: medalId,
    },
  });

  return <MedalAvatar width={32} height={32} s3Key={data.image?.key} />;
};
